import classNames from 'classnames';
import React from 'react';
import './DesignerActionsSeparator.less';

export interface IDesignerActionsSeparatorProps extends React.HTMLProps<HTMLDivElement> {}

export function DesignerActionsSeparator({ className, ...otherProps }: IDesignerActionsSeparatorProps) {
  return <div role="separator" className={classNames('dp-designer-action-separator', className)} {...otherProps}></div>;
}
